import { GetterTree } from "vuex";
import { RootState } from "../types";
import { SchoolState } from "./types";

export const getters: GetterTree<SchoolState, RootState> = {};
